(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4970],{

/***/ 4311:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/StoreLocatorPage",
      function () {
        return __webpack_require__(5269);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9989);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1348);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query storeLocator1($locale: String!, $preview: Boolean, $url: String) {\n        storeLocatorCollection(\n            limit: 1\n            locale: $locale\n            preview: $preview\n            where: { slug: $url }\n        ) {\n            items {\n                countriesCollection(limit: 6) {\n                    items {\n                        ... on RegionSelector {\n                            name\n                            regionName\n                            location {\n                                lat\n                                lon\n                            }\n                            subregionsCollection(limit: 16) {\n                                items {\n                                    ... on RegionSelector {\n                                        regionName\n                                        stores\n                                        location {\n                                            lat\n                                            lon\n                                        }\n                                        zoom\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = (graphql_tag__WEBPACK_IMPORTED_MODULE_1___default()(_templateObject()));


/***/ }),

/***/ 5269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StoreLocatorPage; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./adapters/contentful.adapters.js
var contentful_adapters = __webpack_require__(6320);
// EXTERNAL MODULE: ./adapters/sdc.adapters.js
var sdc_adapters = __webpack_require__(3645);
// EXTERNAL MODULE: ./containers/StoreLocator/StoreLocator.query.js
var StoreLocator_query = __webpack_require__(2768);
// EXTERNAL MODULE: ./containers/StoreLocator/StoreLocator.query.1.js
var StoreLocator_query_1 = __webpack_require__(6468);
// EXTERNAL MODULE: ./components/PGDataLayer/PGDataLayer.js + 1 modules
var PGDataLayer = __webpack_require__(8405);
// EXTERNAL MODULE: ./constants/global.js
var global = __webpack_require__(5379);
// EXTERNAL MODULE: ./components/ChinaStoreLocator/StoreList.js
var StoreList = __webpack_require__(474);
// EXTERNAL MODULE: ./components/ChinaStoreLocator/StoreDetails.js
var StoreDetails = __webpack_require__(7262);
// EXTERNAL MODULE: ./components/ChinaStoreLocator/SearchBox.js
var SearchBox = __webpack_require__(9946);
;// CONCATENATED MODULE: ./styles/components/StoreLocator/StoreLocator-tw-styles.js
/* harmony default export */ var StoreLocator_tw_styles = ({
    fullScreenControlWrapper: "m-10 lg:hidden",
    topWrapper: "storeWrapper flex flex-wrap pt-70 lg:relative",
    /* mapWrapper: 'mapWrapper w-full lg:w-2/3 absolute lg:fixed', */ mapWrapper: "mapWrapper w-full lg:w-2/3 hidden lg:block absolute lg:fixed",
    mapWrapperMob: "mapWrapper mapWrapperMob w-full lg:w-2/3 relative lg:hidden",
    mapContainer: "map-container",
    /* searchBoxWrapper: 'searchbox-wrapper lg:fixed', */ searchBoxWrapper: "searchbox-wrapper lg:absolute lg:justify-center",
    /* searchBoxWrapperTop: 'searchbox-wrapper lg:fixed lg:justify-center', */ searchInputWrapper: "relative china-search",
    searchBoxTitle: "header3 mb-15 text-darkGrey",
    disclaimer: "text-red my-10",
    searchBox: "search-box bestsellerfont4 w-full h-auto shadow-none text-justkGrey rounded-none placeholder-gray-600",
    searchBoxHidden: "search-box-hidden w-full invisible block",
    searchBtnWrapperX: "search-btn-wrapper-x relative",
    searchBtnWrapperXC: "search-btn-wrapper-x",
    searchBtnWrapper: "search-btn-wrapper px-30 lg:px-0 hidden lg:block",
    /* searchBtnWrapper: 'search-btn-wrapper hidden lg:block',*/ searchBtnWrapperMob: "search-btn-wrapper px-30 block lg:hidden",
    searchBtn: "search-btn absolute",
    /* searchButton: 'new-storehbtn bg-red text-white p-10 my-20 lg:mt-30 ', */ searchButton: "new-storehbtn bg-red text-white p-10 my-20 lg:mt-30",
    rightPanel: "sl right-panel w-full lg:relative",
    searchCrossBtn: "search-cross-btn absolute",
    storeListWrapper: "storeList pb-20",
    blockHide: "pb-0 lg:pb-0",
    storeDetailsWrapper: "store-details pb-20 lg:pb-0",
    mapMarkerIcon: "map-marker-icon",
    default: {
        //common for all locators
        mapContainer: "map-container",
        searchBoxWrapper: "searchbox-wrapper lg:fixed",
        searchInputWrapper: "relative",
        disclaimer: "text-red my-10",
        searchBoxHidden: "search-box-hidden w-full invisible block",
        storeDetailsWrapper: "store-details pb-20 lg:pb-0",
        mapMarkerIcon: "map-marker-icon",
        //storeDetails
        storeDetails: {
            storeTilesWrapper: "storeList",
            storeTiles: "store-tiles",
            storeName: "s-details header4 mb-8 text-darkGrey storeName font-bold",
            storeDesc: "body-small mb-20 text-darkGrey storeDesc",
            bottomSectionWrap: "flex flex-wrap eyebrow-small text-darkGrey",
            phStyle: "ph flex-auto",
            distanceStyle: "ph flex-none text-justGrey text-right mr-5 small-caps",
            directionStyle: "ph flex-none text-red text-right small-caps uppercase",
            crossWrapper: "cross-wrapper",
            cross: "cross",
            instore: "border-black m-45 pt-15 InstoreWrapper",
            instoreTitle: "bestsellerfont3 text-darkGrey",
            instoreaddress: "body-small mt-10 text-darkGrey"
        }
    },
    //specific to gen3 store
    store: {
        searchBox: "search-box bestsellerfont4 w-full h-auto shadow-none text-justkGrey rounded-none placeholder-gray-600",
        searchBtnWrapper: "search-btn-wrapper relative px-30 lg:px-0 hidden lg:block",
        searchBtn: "search-btn absolute",
        searchBtnWrapperMob: "search-btn-wrapper px-30 block lg:hidden",
        searchButton: "new-storehbtn bg-red text-white p-10 my-20 lg:mt-30",
        searchCrossBtn: "search-cross-btn absolute",
        searchBtnWrapperX: "search-btn-wrapper-x relative",
        storeListheading: {
            text: "listcount body-small text-almostBlack",
            mainWrapper: ""
        },
        storeList: {
            storeTiles: "store-tiles",
            storeName: "header4 mb-8 text-darkGrey storeName",
            storeDesc: "body-small mb-20 text-darkGrey storeDesc",
            bottomSectionWrap: "flex flex-wrap eyebrow-small text-darkGrey",
            phStyle: "ph flex-auto",
            distanceStyle: "ph flex-none text-justGrey text-right mr-5 small-caps",
            directionStyle: "ph flex-none text-red text-right small-caps uppercase"
        },
        //markerURL: 'https://res.cloudinary.com/mtree/image/upload/w_auto,q_auto,f_svg,fl_sanitize/SKII-JP-Nocompetition/2X5yhvE3DdePjl3B4hjGaO/276c779d1aa630f22d6d1f5d8213887b/pin-icon-red.svg',
        findStore: {
            topWrapper: "storeWrapper flex flex-wrap pt-70 lg:relative",
            mapWrapper: "mapWrapper w-full lg:w-2/3 static lg:fixed",
            searchBoxTitle: "header3 mb-15 text-darkGrey",
            rightPanel: "right-panel w-full lg:relative",
            storeListWrapper: "storeList  pb-20 lg:pb-0"
        }
    },
    //specific to now  store
    nowStore: {
        storeList: {
            storeTiles: "store-tiles border-b border-lightGrey ",
            storeName: "storeName  nwappt-timemonth lg:text-justblack",
            storeButton: "nowPrimary text-link w-full bg-red rounded py-10 mb-16 lg:mb-30 mt-20 text-white min-h-44",
            storeDesc: "body-small text-16 mt-5 text-almostBlack lg:text-justblack text-left storeDesc keep-all",
            bottomSectionWrap: "flex flex-wrap eyebrow-small text-darkGrey mt-5",
            phStyle: "ph flex-auto body-small text-16 text-left text-almostBlack lg:text-justblack",
            distanceStyle: "ph flex-none text-justGrey text-right ml-5 small-caps text-14 md:text-16",
            directionStyle: "ph flex-none text-right underline body-footer text-justGrey lg:text-justblack"
        },
        //markerURL: 'https://res.cloudinary.com/mtree/image/upload/w_auto,q_auto,f_svg,fl_sanitize/SKII-JP-Nocompetition/2X5yhvE3DdePjl3B4hjGaO/276c779d1aa630f22d6d1f5d8213887b/pin-icon-red.svg',
        storeListheading: {
            text: "listcountapt small-text bg-lightgrey1 text-justGrey text-center lg:text-left",
            mainWrapper: "block text-center lg:text-left",
            disclamierText: "text-red small-text pt-15 lg:pt-20 pb-6 text-center lg:text-left px-25 lg:px-0"
        },
        mapMarkerIcon: "map-marker-icon",
        disclaimer: "text-red my-10",
        searchBtnWrapper: "search-btn-wrapper",
        searchBtn: "nwappt-search-btn absolute",
        labelStyles: "hidden",
        searchCrossBtn: "search-cross-btn-appt absolute",
        searchBox: "nowapptlocator-search-box border-b focus:outline-none outline-none border-darkGrey pb-10 pl-5 pr-35 body-medium w-full h-auto shadow-none text-justkGrey rounded-none",
        appointmentStore: {
            topWrapper: "appointment storeWrapper flex flex-wrap mt-60 lg:mt-80",
            mapWrapper: "mapWrapper-locator w-full lg:w-7/12  lg:fixed mapWrapper-locatormobile",
            searchBoxTitle: "header4 mt-40 lg:mt-5 mb-25 lg:mb-50 text-darkGrey lg:text-black",
            rightPanel: "nwaptright-panel bg-white w-full lg:relative nwaptright-panelmobile",
            storeListWrapper: "storeList mx-25 lg:mx-0 pb-20 lg:pb-0"
        },
        redeemStore: {
            topWrapper: "storeWrapper flex flex-wrap h-full w-full",
            mapWrapper: "min-h-445 lg:min-h-auto w-full lg:w-7/12 h-full lg:absolute lg:top-0 lg:left-0 mapWrapper-locatormobile",
            searchBoxTitle: "header4 mt-20 lg:mt-5 mb-30 lg:mb-50 text-darkGrey lg:text-black",
            rightPanel: "rdmright-panel nwaptright-panel bg-white w-full lg:absolute lg:top-0 nwaptright-panelmobile lg:overflow-y-auto",
            storeListWrapper: "storeList lg:px-0 pb-20 lg:pb-0",
            suggestionStyles: "suggestion-list"
        }
    }
});

// EXTERNAL MODULE: ../node_modules/react-baidu-maps/lib/index.js
var lib = __webpack_require__(1119);
;// CONCATENATED MODULE: ./components/ChinaStoreLocator/Map.js





function Map(props) {
    const AsyncBaiduMap = (0,lib/* asyncWrapper */.kB)(lib/* BaiduMap */.Gp);
    const { zoom , center , onLoadMap , changeMarker , allStores , apiKey , updateStore  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AsyncBaiduMap, {
        zoom: zoom,
        enableDragging: true,
        enableScrollWheelZoom: true,
        enableDoubleClickZoom: true,
        enableMapClick: true,
        center: center,
        mapUrl: "https://api.map.baidu.com/api?v=2.0&ak=".concat(apiKey),
        loadingElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "Loading map..."
        }),
        mapContainer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: StoreLocator_tw_styles.mapContainer,
            style: {
                height: "100%",
                width: "100%"
            }
        }),
        onMapInstantiated: (instance)=>{
            onLoadMap(instance);
        },
        onZoomend: updateStore,
        onDragend: updateStore,
        onClick: (e)=>console.warn("map click :", e.point),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* NavigationControl */.Pv, {
                type: "BMAP_NAVIGATION_CONTROL_ZOOM",
                anchor: "bottom_right",
                offset: {
                    width: 0,
                    height: 30
                }
            }),
            allStores.map((position, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Marker */.Jx, {
                    title: position.name,
                    position: {
                        lng: position.lan,
                        lat: position.lat
                    },
                    onClick: ()=>changeMarker(position)
                }, index))
        ]
    });
}
Map.propTypes = {
    mapStyle: (prop_types_default()).array,
    zoom: (prop_types_default()).number,
    center: (prop_types_default()).object,
    onLoadMap: (prop_types_default()).func,
    updateStore: (prop_types_default()).func,
    maxZoomCluster: (prop_types_default()).number,
    onClusterClick: (prop_types_default()).func,
    changeMarker: (prop_types_default()).func,
    allStores: (prop_types_default()).array,
    apiKey: (prop_types_default()).string
};
/* harmony default export */ var ChinaStoreLocator_Map = (/*#__PURE__*/(0,react.memo)(Map));

// EXTERNAL MODULE: ./styles/components/StoreLocator/ChinaStoreLocator-tw-styles.js
var ChinaStoreLocator_tw_styles = __webpack_require__(6528);
;// CONCATENATED MODULE: ./components/ChinaStoreLocator/mapStyle.js
/* harmony default export */ var mapStyle = ([
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
]);

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(4354);
// EXTERNAL MODULE: ./helpers/TravelLocation.js
var TravelLocation = __webpack_require__(867);
;// CONCATENATED MODULE: ./components/ChinaStoreLocator/index.js
/* eslint-disable no-undef */ /* eslint-disable react/prop-types */ 


// import PropTypes from "prop-types"









class ChinaStoreLocator extends react.Component {
    componentDidMount() {
        const currentCountry = this.findCurrentCountry();
        const { storeData: { storeData: { location  }  }  } = this.props;
        this.setState({
            isMobile: window.innerWidth < global.breakpoints.sP ? true : false,
            center: {
                lat: Number(currentCountry.location ? currentCountry.location.lat : location.lat),
                lng: Number(currentCountry.location ? currentCountry.location.lon : location.lng)
            }
        });
        window.addEventListener("resize", this.determineResiz);
        if (true) {
            window.addEventListener("resize", ()=>{
                this.setState({
                    triggerUpdate: true
                });
            });
            const { pageReview  } = this.props.storeData;
            const localRegoin = (0,TravelLocation/* default */.Z)(this.props.countrySelector.country);
            if (!window.dataLayer.find((item)=>item.GAeventLabel === "".concat(localRegoin, "_").concat(pageReview))) {
                // eslint-disable-next-line no-undef
                dataLayer.push({
                    "event": "customEvent",
                    "GAeventCategory": "event_informational_action",
                    "GAeventAction": "event_view_page",
                    "GAeventLabel": "".concat(localRegoin, "_").concat(pageReview),
                    "GAeventValue": 0,
                    "GAeventNonInteraction": true
                });
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.determineResiz);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.center !== prevState.center) this.prevView.center = prevState.center;
        if (this.state.zoom !== prevState.zoom) this.prevView.zoom = prevState.zoom;
    }
    render() {
        const { apiKey  } = this.props;
        const { storeData: { storeData: { bounds , store  } , countriesCollection , placeholderMessage , errorMessageEmpty , errorMessageInvalid , directions , foundStorePart1 , foundStorePart2  }  } = this.props;
        const currentCountry = this.findCurrentCountry();
        const { center , zoom , storeList , searchAddress , selectedStore , detailShow , showList , isMobile , showError , goBack  } = this.state;
        let storeListAll = [];
        store.map((val)=>{
            storeListAll.push({
                name: val.name,
                add: val.add,
                ph: val.ph,
                lat: val.lat,
                lng: val.lan,
                result: val.name + " " + val.add
            });
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: ChinaStoreLocator_tw_styles/* default.topWrapper */.Z.topWrapper,
            children: [
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: ChinaStoreLocator_tw_styles/* default.mapWrapper */.Z.mapWrapper,
                    id: "map",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChinaStoreLocator_Map, {
                        mapStyle: mapStyle,
                        zoom: zoom,
                        apiKey: apiKey,
                        center: center,
                        isMobile: isMobile,
                        onLoadMap: this.onLoadMap,
                        changeMarker: this.changeMarker,
                        allStores: this.allStores,
                        updateStore: this.updateStore
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ChinaStoreLocator_tw_styles/* default.rightPanel */.Z.rightPanel + (storeList.length === 0 ? " centeraligned" : " searchTopFix search-error"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* default */.Z, {
                            searchAddress: searchAddress,
                            countryBounds: bounds,
                            callBack: this.onSearchRelocate,
                            callBackCity: this.onSearchCity,
                            placeholderMessage: placeholderMessage,
                            storeList: storeListAll,
                            isMobile: isMobile,
                            errorMessageEmpty: errorMessageEmpty,
                            errorMessageInvalid: errorMessageInvalid,
                            hideList: this.hideList,
                            removeList: this.removeList,
                            options: store,
                            detailShow: this.detailShowFunction,
                            countrySelector: currentCountry,
                            countriesCollection: countriesCollection,
                            showList: this.showListFunction,
                            showError: this.showErrorFunc,
                            goBack: this.goBack
                        }),
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: ChinaStoreLocator_tw_styles/* default.mapWrapperMob */.Z.mapWrapperMob,
                            id: "map",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChinaStoreLocator_Map, {
                                mapStyle: mapStyle,
                                zoom: zoom,
                                center: center,
                                apiKey: apiKey,
                                onLoadMap: this.onLoadMap,
                                changeMarker: this.changeMarker,
                                allStores: this.allStores,
                                isMobile: isMobile,
                                updateStore: this.updateStore
                            })
                        }),
                        !detailShow && showList && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: !showError ? ChinaStoreLocator_tw_styles/* default.storeDetailsWrapper */.Z.storeDetailsWrapper : ChinaStoreLocator_tw_styles/* default.storeDetailsWrappererror */.Z.storeDetailsWrappererror,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: this.showRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreList/* default */.Z, {
                                    storeList: storeList,
                                    callBack: this.changeMarker,
                                    directions: directions,
                                    foundStorePart1: foundStorePart1,
                                    foundStorePart2: foundStorePart2,
                                    scrollToList: this.scrollToList
                                })
                            ]
                        }),
                        detailShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ChinaStoreLocator_tw_styles/* default.storeDetailsWrapper */.Z.storeDetailsWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: this.detailRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetails/* default */.Z, {
                                    selectedStore: selectedStore,
                                    scrollToList: this.scrollToDetail,
                                    callBack: this.onCloseStoreDetail,
                                    goBack: goBack,
                                    goBackFunction: this.goBackFunction
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        var _this;
        const { storeData: { storeData: { location , store , options: { initialZoom  }  }  }  } = props;
        super(props), _this = this;
        (0,_define_property/* default */.Z)(this, "changeMarker", (marker, msg)=>{
            const { storeData: { gaLabel , markerGaEventCategory , markerGaEventAction  }  } = this.props;
            if (msg) {
                this.setState({
                    goBack: true
                });
            }
            let point = new BMap.Point(marker.lan, marker.lat);
            this.mapRef.map.centerAndZoom(point, 14);
            this.setState({
                selectedStore: marker,
                detailShow: true,
                triggerUpdate: true,
                showList: true
            });
            // eslint-disable-next-line no-undef
            dataLayer.push({
                event: "customEvent",
                GAeventCategory: "".concat(markerGaEventCategory),
                GAeventAction: "".concat(markerGaEventAction),
                GAeventLabel: "".concat(gaLabel, "_click_location tag")
            });
        });
        (0,_define_property/* default */.Z)(this, "goBack", ()=>{
            this.setState({
                goBack: false
            });
        });
        (0,_define_property/* default */.Z)(this, "determineResiz", ()=>{
            this.setState({
                isMobile: window.innerWidth < global.breakpoints.sP ? true : false
            });
        });
        (0,_define_property/* default */.Z)(this, "findCurrentCountry", ()=>{
            const { storeData: { countriesCollection  } , countrySelector  } = this.props;
            const currentCountry = countriesCollection.items.find((eachCountry)=>eachCountry.regionName === countrySelector.country);
            return currentCountry;
        });
        (0,_define_property/* default */.Z)(this, "onLoadMap", (ref)=>{
            this.mapRef = ref;
            if (navigator) {
                navigator.geolocation.getCurrentPosition((position)=>{
                    let latLngObj = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    let point = new BMap.Point(latLngObj.lng, latLngObj.lat);
                    this.mapRef.centerAndZoom(point, 14);
                    this.mapRef.panTo(point);
                    let geocoder = new BMap.Geocoder();
                    geocoder.getLocation(point, (results)=>{
                        if (results) {
                            this.setState({
                                searchAddress: results.address
                            });
                        } else {
                            window.alert("No results found");
                        }
                    });
                });
            }
        });
        (0,_define_property/* default */.Z)(this, "onSearchRelocate", (searchAddress)=>{
            let pp = new BMap.Point(searchAddress.lan, searchAddress.lat);
            this.mapRef.map.centerAndZoom(pp, 14);
            let marker = new BMap.Marker(pp);
            this.mapRef.map.addOverlay(marker);
            this.setState({
                selectedStore: searchAddress,
                detailShow: true
            });
        });
        (0,_define_property/* default */.Z)(this, "onSearchCity", function(searchAddress, cityStores) {
            let zoom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 14;
            let pp = new BMap.Point(searchAddress.lon, searchAddress.lat);
            _this.mapRef.map.centerAndZoom(pp, zoom);
            _this.setState({
                detailShow: false,
                showList: true,
                storeList: cityStores.store
            });
        });
        (0,_define_property/* default */.Z)(this, "onCloseStoreDetail", ()=>{
            this.setState({
                detailShow: false,
                triggerUpdate: true,
                selectedStore: null,
                storeList: [],
                crossIcon: false,
                center: this.prevView.center,
                zoom: this.prevView.zoom
            });
        });
        (0,_define_property/* default */.Z)(this, "hideList", ()=>{
            this.setState({
                showList: false
            });
        });
        (0,_define_property/* default */.Z)(this, "removeList", ()=>{
            this.setState({
                storeList: [],
                showList: true,
                detailShow: false,
                showError: false
            });
        });
        (0,_define_property/* default */.Z)(this, "detailShowFunction", ()=>{
            this.setState({
                detailShow: !this.state.detailShow
            });
        });
        (0,_define_property/* default */.Z)(this, "showListFunction", ()=>{
            this.setState({
                showList: false
            });
        });
        (0,_define_property/* default */.Z)(this, "showErrorFunc", ()=>{
            this.setState({
                showError: true
            });
        });
        (0,_define_property/* default */.Z)(this, "scrollToList", ()=>{
            const { isMobile  } = this.state;
            let offset = isMobile ? 120 : 10 // sticky nav height
            ;
            let el = document.querySelector(".store-details") // element you are scrolling to
            ;
            window.scroll({
                top: el.offsetTop - offset,
                left: 0,
                behavior: "smooth"
            });
        // this.showRef.current.scrollIntoView({
        //     behaviour: "smooth"
        // })
        });
        (0,_define_property/* default */.Z)(this, "scrollToDetail", ()=>{
            this.detailRef.current.scrollIntoView({
                behaviour: "smooth"
            });
        });
        (0,_define_property/* default */.Z)(this, "updateStore", async ()=>{
            const { storeData: { storeData: { options: { zoomOnMarkerClick  }  }  }  } = this.props;
            if (this.mapRef && this.state.selectedStore) {
                let storepoint = new BMap.Point(this.state.selectedStore.lan, this.state.selectedStore.lat);
                let currentZoom = this.mapRef.map.getZoom();
                let currentCenter = this.mapRef.map.getCenter();
                if (currentZoom < zoomOnMarkerClick && storepoint != currentCenter) {
                    this.setState({
                        detailShow: false,
                        triggerUpdate: true,
                        selectedStore: null,
                        storeList: []
                    });
                }
            }
        });
        (0,_define_property/* default */.Z)(this, "goBackFunction", ()=>{
            this.setState({
                showList: true,
                // storeList:
                detailShow: false
            });
        });
        this.state = {
            showErrorMessage: false,
            center: {
                lat: Number(location.lat),
                lng: Number(location.lng)
            },
            isMobile: null,
            zoom: initialZoom,
            clusterClick: false,
            storeList: [],
            showList: false,
            showError: false,
            selectedStore: null,
            triggerUpdate: false,
            detailShow: false,
            searchAddress: "",
            goBack: "false"
        };
        this.mapRef = null;
        this.allStores = store;
        this.prevView = {};
        this.service = null;
        this.map = null;
        this.showRef = /*#__PURE__*/ react.createRef(null);
        this.detailRef = /*#__PURE__*/ react.createRef(null);
    }
}
const mapStateToProps = (state)=>{
    return {
        countrySelector: state.changeCountryReducer
    };
};
/* harmony default export */ var components_ChinaStoreLocator = ((0,es/* connect */.$j)(mapStateToProps)(ChinaStoreLocator));

// EXTERNAL MODULE: ./components/PageMetadata/index.js
var PageMetadata = __webpack_require__(5865);
;// CONCATENATED MODULE: ./containers/StoreLocator/index.js
/* provided dependency */ var process = __webpack_require__(7061);













class HomepageContainer extends react.Component {
    static async getInitialProps(param) {
        let { query  } = param;
        try {
            const storeLocatorData = await (0,contentful_adapters.getPage)("storeLocatorCollection", StoreLocator_query/* default */.Z);
            const storeLocatorData1 = await (0,contentful_adapters.getPage)("storeLocatorCollection", StoreLocator_query_1/* default */.Z);
            if (!storeLocatorData.disableLiveStoreData) {
                const liveStoresData = await (0,sdc_adapters.getStores)();
                if (liveStoresData) {
                    if (false) {}
                    storeLocatorData.storeData.store = liveStoresData;
                }
            }
            return {
                data: {
                    ...storeLocatorData,
                    ...storeLocatorData1
                },
                pageContext: query,
                template: global.contentType.storeLocatorPage,
                header: global.headerStyle.bgWhite
            };
        } catch (err) {
            console.error("Error", JSON.stringify(err));
        }
    }
    render() {
         true && this.storelocAddClass();
        const { data , router  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PGDataLayer/* default */.Z, {
                    locale: "zh-CN",
                    pageType: global.contentType.storeLocatorPage,
                    path: decodeURI(router.asPath),
                    title: data && data.pageMetadata && data.pageMetadata.metaTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetadata/* default */.Z, {
                    data: data && data.pageMetadata,
                    path: router && router.asPath
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChinaStoreLocator, {
                    apiKey: process.env.BAIDU_MAP_KEY,
                    storeData: data
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,_define_property/* default */.Z)(this, "storelocAddClass", ()=>{
            document.querySelector("html").classList.add("storeloc");
        });
    }
}
(0,_define_property/* default */.Z)(HomepageContainer, "propTypes", {
    data: prop_types_default().oneOfType([
        (prop_types_default()).object
    ]).isRequired,
    router: prop_types_default().oneOfType([
        (prop_types_default()).object
    ]).isRequired
});
/* harmony default export */ var StoreLocator = ((0,router.withRouter)(HomepageContainer));

;// CONCATENATED MODULE: ./pages/StoreLocatorPage.js

/* harmony default export */ var StoreLocatorPage = (StoreLocator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4791,2584,4206,1119,3540,5922,9774,2888,179], function() { return __webpack_exec__(4311); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);